import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@headlessui/react';
import cn from 'classnames';

function SwitchToggle({
  onChange,
  value,
  containerClassName,
  label,
  labelClassName,
}) {
  return (
    <Switch.Group>
      <div
        className={cn(
          containerClassName,
          'flex items-center space-x-2 px-1 py-[0.15rem] rounded-full',
          value ? 'bg-green-500/20' : 'bg-red-500/20',
        )}
      >
        <Switch
          checked={value}
          onChange={onChange}
          className={cn(
            value ? 'bg-green-500' : 'bg-red-700',
            'relative inline-flex flex-shrink-0 h-[18px] w-[35px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75',
          )}
        >
          <span className="sr-only">Switch Toggle</span>
          <span
            aria-hidden="true"
            className={cn(
              value ? 'translate-x-4' : 'translate-x-[0.04rem]',
              'pointer-events-none inline-block h-[14px] w-[14px] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200',
            )}
          />
        </Switch>
        {label && (
          <Switch.Label
            className={cn(
              'ml-2 font-[500] text-sm text-gray-800 tracking-wide',
              labelClassName,
            )}
          >
            {label}
          </Switch.Label>
        )}
      </div>
    </Switch.Group>
  );
}

SwitchToggle.defaultProps = {
  label: '',
  containerClassName: '',
  labelClassName: '',
  onChange: () => {},
};

SwitchToggle.propTypes = {
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
};

export default SwitchToggle;
